import React from 'react';

const FeaturesInline = props => (
  <div className="business-feature-1x business-feature-onslider">
    <div className="container">
      <div className="business-features">
        <div className="col-md-12">
          <div className="row">
            {props.featuresInline.map(feature => (
              <div className="col-md-4 no-padding" key={feature.icon}>
                <div className="single-features single-features-overlay">
                  <div className="media">
                    <img className="mr-3" src={feature.icon} alt="Placeholder" />
                    <div className="media-body">
                      <h5 className="mt-0">{feature.title}</h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="padding-top-large" />
  </div>
);

export default FeaturesInline;



// WEBPACK FOOTER //
// ./src/components/FeaturesInline.js